// @ts-nocheck
import Scene from "~/scene";

export default class CursorManager {
	constructor() {
		this._rqs = [];
	}

	add(data) {
		const id = {}; // tohle by melo jako identifikator stacit, protoze {} != {}

		this._rqs.push({
			data,
			id,
		});
		this._setData();

		return id;
	}

	remove(id) {
		this._remove(id);
	}

	update(id, data) {
		for (let index = 0; index < this._rqs.length; index++) {
			if (this._rqs[index].id === id) {
				this._rqs[index].data = data;
				this._setData();
				break;
			}
		}
	}

	_remove(id) {
		for (let index = 0; index < this._rqs.length; index++) {
			if (this._rqs[index].id === id) {
				this._rqs.splice(index, 1);
				this._setData();
				break;
			}
		}
	}

	_setData() {
		if (this._rqs.length) { // pokud je neco ve fronte
			let cursor = null;
			let callback = null;

			for (let index = this._rqs.length - 1; index >= 0; index--) {
				const rq = this._rqs[index];

				if (!callback && rq.data && rq.data.callback) {
					callback = rq.data.callback;
				}

				if (!cursor && rq.data && rq.data.cursor) {
					cursor = rq.data.cursor;
				}
			}

			// klikani
			Scene.setMapClick(callback);

			// kurzor
			Scene.setCursor(cursor);
		} else { // nikdo uz nic nechce
			Scene.setCursor(null);
			Scene.setMapClick(null);
		}
	}
}
